import useMediaQuery from "./useMediaQuery";

/**
 * Single shared mobile threshold for the whole app shell — Tailwind's `md`.
 * Below this, Sidebar+Topbar are replaced by AppBar+BottomTabBar. Previously
 * Header.tsx and Sidebar.tsx disagreed (767px vs antd's 992px `lg`).
 */
export const MOBILE_BREAKPOINT = 768;

export default function useIsMobile(): boolean {
  return useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
}
